import type { DateIso } from '../../types/domain';
import { isoStr } from './base';

/* ── Utilitaires date ── */
export function getHolidays(year: number): Set<DateIso> {
  function paques(y: number): Date {
    const a = y % 19,
      b = Math.floor(y / 100),
      c = y % 100,
      d = Math.floor(b / 4),
      e = b % 4,
      f = Math.floor((b + 8) / 25),
      g = Math.floor((b - f + 1) / 3),
      h = (19 * a + b - d - g + 15) % 30,
      i = Math.floor(c / 4),
      k = c % 4,
      l = (32 + 2 * e + 2 * i - h - k) % 7,
      m = Math.floor((a + 11 * h + 22 * l) / 451),
      month = Math.floor((h + l - 7 * m + 114) / 31),
      day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, month - 1, day);
  }
  const p = paques(year);
  const add = (d: Date, n: number): DateIso => {
    const x = new Date(d);
    x.setDate(x.getDate() + n);
    return isoStr(x);
  };
  return new Set([
    `${year}-01-01`,
    add(p, 1), // Lundi de Pâques
    `${year}-05-01`,
    `${year}-05-08`,
    add(p, 39), // Ascension
    // Pentecôte exclue
    `${year}-07-14`,
    `${year}-08-15`,
    `${year}-11-01`,
    `${year}-11-11`,
    `${year}-12-25`,
  ]);
}

export const holidaysCache: Record<number, Set<DateIso>> = {};

export function getHolidaysCached(year: number): Set<DateIso> {
  if (!holidaysCache[year]) holidaysCache[year] = getHolidays(year);
  return holidaysCache[year];
}
